import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "contentSection",
    "documentSection",
    "typeInput",
    "contentFieldsInput",
    "documentFieldsInput",
  ];

  connect() {
    this.toggle();
  }

  toggle() {
    const selectedType =
      this.typeInputTargets.find((input) => input.checked)?.value || "content";

    const isContent = selectedType === "content";

    this.contentSectionTarget.classList.toggle("d-none", !isContent);
    this.documentSectionTarget.classList.toggle("d-none", isContent);

    if (this.hasContentFieldsInputTarget) {
      this.contentFieldsInputTarget.disabled = !isContent;
    }
    if (this.hasDocumentFieldsInputTarget) {
      this.documentFieldsInputTarget.disabled = isContent;
    }
  }
}
